/**
 * Compares two arrays for equality, ignoring order.
 * Assumes primitive values (e.g., string, number).
 */
export function arraysEqualUnordered<T>(
  a: T[],
  b: T[],
  { ignoreDuplicates = false }: { ignoreDuplicates?: boolean } = {},
): boolean {
  if (a.length !== b.length && !ignoreDuplicates) {
    return false;
  }

  if (ignoreDuplicates) {
    const setA = new Set(a);
    const setB = new Set(b);

    if (setA.size !== setB.size) {
      return false;
    }

    for (const val of setA) {
      if (!setB.has(val)) {
        return false;
      }
    }

    return true;
  }

  const sortedA = [...a].sort();
  const sortedB = [...b].sort();

  return sortedA.every((val, idx) => val === sortedB[idx]);
}
